import { render, staticRenderFns } from "./ButtonsHeaderList.vue?vue&type=template&id=1c60484f&"
import script from "./ButtonsHeaderList.vue?vue&type=script&lang=js&"
export * from "./ButtonsHeaderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports